import { DBModel } from './DBModel';

export class TAGImageCategory extends DBModel {
  alias: string = '';
  title: string = '';
  description: string = '';

  createdate: Date = new Date();

  eventid: string = undefined;

  isPublic: boolean = false;

  constructor(info: any = {}) {
    super();
    this.deserialize(info);
  }

  override serialize(): any {
    var obj: any = super.serialize();

    obj.alias = this.alias;
    obj.title = this.title;
    obj.description = this.description;

    obj.createdate = this.createdate;

    obj.eventid = this.eventid;

    obj.isPublic = this.isPublic;

    return obj;
  }

  override deserialize(data: any) {
    super.deserialize(data);

    if (data.alias != null) this.alias = data.alias;
    if (data.title != null) this.title = data.title;
    if (data.description != null) this.description = data.description;

    if (data.createdate != null) this.createdate = new Date(data.createdate);

    if (data.eventid != null) this.eventid = data.eventid;

    if (data.isPublic != null) this.isPublic = data.isPublic;
  }
}
